export default "__VITE_ASSET__M8M$SdLI__"